/* PDP "Build your bundle" selector (shipped from A/B 1cb20da2, no add-ons arm).
 *
 * Decorates the live kit (#rio-pdp-kit-box, assets/rio-pdp-kit.js). Tiles are
 * multi-select. Every change is pushed through one hidden "combo" swatch, so
 * the kit keeps owning the hidden toggles, qty, and the ATC total. The
 * Adventure add-ons block is left alone. Add-ons that count toward the tier
 * (U.S. National Parks) are included in the set count.
 *
 * v2: the viewed product tile can be deselected (the add to cart submit is
 * then handled here, extras only); tier percents come from the live theme
 * math and the script stands down if the announcement bar offer disagrees;
 * copy mentions free shipping on 2+ units like the on-site offer.
 */
(function () {
  if (window.__rioSelBoot) return;
  window.__rioSelBoot = true;

  var ROOT_ID = 'rio-pdp-kit-box';
  var COMBO_KEY = 'rio-sel-combo';
  var TIER_MAX = 3;
  // On-site offer (Anniversary, Oct 2026): free shipping on 2+ units.
  var FREE_SHIP_UNITS = 2;
  var FALLBACK_PCT = { 1: 15, 2: 25, 3: 30 };
  var ORD = { 1: '1st', 2: '2nd', 3: '3rd', 4: '4th', 5: '5th' };
  var WORDS = { 2: 'both', 3: 'all three', 4: 'all four' };

  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function esc(v) {
    return String(v == null ? '' : v).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;');
  }
  function setText(el, text) {
    if (el && el.textContent !== text) el.textContent = text;
  }
  function setAttr(el, name, value) {
    if (el && el.getAttribute(name) !== value) el.setAttribute(name, value);
  }
  function money(cents) { return '$' + (Number(cents || 0) / 100).toFixed(2); }

  /* ---------- pricing (mirrors theme RioIgPrice) ---------- */

  function pctFor(n) {
    var tier = Math.min(Math.max(n, 1), TIER_MAX);
    var r = window.RioIgPrice;
    if (r && typeof r.volumeDiscountPct === 'function') {
      var p = Number(r.volumeDiscountPct(tier));
      if (p > 0) return p;
    }
    return FALLBACK_PCT[tier];
  }

  // Stand down if the announcement bar offer is not the one the theme math prices.
  function offerMatches() {
    var els = qsa('.announcement-bar-bundle__tier');
    for (var i = 0; i < els.length; i++) {
      var m = /BUY\s*(\d+)\D+?(\d+)\s*%/i.exec((els[i].textContent || '').replace(/\s+/g, ' '));
      // Qty 1 follows the Intelligems qty-1 test arm; the bar text is hydrated to the same value.
      if (m && parseInt(m[1], 10) === 1 && window.RioIgPrice && window.RioIgPrice.qtyOnePct &&
          (parseInt(m[2], 10) === 15 || parseInt(m[2], 10) === window.RioIgPrice.qtyOnePct())) continue;
      if (m && pctFor(parseInt(m[1], 10)) !== parseInt(m[2], 10)) return false;
    }
    return true;
  }

  function unitCents(list, n) {
    if (!(list > 0)) return 0;
    var r = window.RioIgPrice;
    if (n <= 1) {
      if (r && typeof r.qtyOneSaleCents === 'function') return r.qtyOneSaleCents(list);
      return list - Math.floor((list * pctFor(1)) / 100);
    }
    if (r && typeof r.applyPercentOffCents === 'function') return r.applyPercentOffCents(list, pctFor(n));
    return list - Math.round((list * pctFor(n)) / 100);
  }

  function totalCents(lists, n) {
    var sum = 0;
    for (var i = 0; i < lists.length; i++) sum += unitCents(lists[i], n);
    return sum;
  }

  function productHandle() {
    var m = (location.pathname || '').toLowerCase().match(/\/products\/([^/?#]+)/);
    if (m && m[1]) return decodeURIComponent(m[1]);
    var p = window.__RIO_KIT_PRODUCT;
    return p && p.handle ? String(p.handle).toLowerCase() : '';
  }

  function currentVariantId() {
    var form = qs('form.main-product-form');
    var input = form && form.querySelector('input[name="id"], select[name="id"]');
    return input && input.value ? String(input.value) : '';
  }

  function cachedCents(variantId) {
    var cache = window.__RIO_KIT_ADDONS || {};
    var keys = Object.keys(cache);
    for (var i = 0; i < keys.length; i++) {
      var item = cache[keys[i]];
      if (item && item.priceCents && String(item.variantId) === String(variantId)) return item.priceCents;
    }
    var cur = cache[productHandle()];
    if (cur && cur.priceCents && String(cur.variantId) === String(variantId)) return cur.priceCents;
    return 0;
  }

  function listCents(variantId) {
    if (!variantId) return 0;
    var fallback = 0;
    var btn = qs('[data-city-product-multi-add-toggle][data-variant-id="' + variantId + '"]');
    if (btn) fallback = parseInt(btn.getAttribute('data-variant-price-cents'), 10) || 0;
    if (!fallback) fallback = cachedCents(variantId);
    if (!fallback && String(variantId) === currentVariantId()) {
      var q = qs('.quantity_selector');
      fallback = (q && parseInt(q.dataset.price, 10)) || 0;
    }
    var r = window.RioIgPrice;
    var getter = (r && r.__rioSelOrigGetList) || (r && r.getListPriceCents);
    if (typeof getter === 'function') return getter.call(r, variantId, fallback) || fallback;
    return fallback;
  }

  /* ---------- state ---------- */

  function tilesOf(root) { return qsa('.rio-sel__tile', root); }
  function isOn(tile) { return tile.getAttribute('aria-pressed') === 'true'; }

  function eligibleAddonLists(root) {
    var boxes = qsa('.rio-pdp-addon__check:checked', root);
    var lists = [];
    for (var i = 0; i < boxes.length; i++) {
      if (boxes[i].getAttribute('data-promo-excluded') === 'true') continue;
      var c = listCents(boxes[i].getAttribute('data-variant-id'));
      if (c > 0) lists.push(c);
    }
    return lists;
  }

  function selectedLists(root) {
    var lists = [];
    var tiles = tilesOf(root);
    for (var i = 0; i < tiles.length; i++) {
      if (!isOn(tiles[i])) continue;
      var c = parseInt(tiles[i].getAttribute('data-cents'), 10) || 0;
      if (c > 0) lists.push(c);
    }
    return lists.concat(eligibleAddonLists(root));
  }

  function excludedAddonCents(root) {
    var boxes = qsa('.rio-pdp-addon__check:checked', root);
    var sum = 0;
    for (var i = 0; i < boxes.length; i++) {
      if (boxes[i].getAttribute('data-promo-excluded') !== 'true') continue;
      sum += listCents(boxes[i].getAttribute('data-variant-id'));
    }
    return sum;
  }

  function viewedOff(root) {
    var solo = qs('.rio-sel__tile[data-key="solo"]', root);
    return !!solo && !isOn(solo);
  }

  function checkedAddonCount(root) {
    return qsa('.rio-pdp-addon__check:checked', root).length;
  }

  function selectedTileCount(root) {
    return tilesOf(root).filter(isOn).length;
  }

  function unitCount(root) {
    var addons = qsa('.rio-pdp-addon__check:checked', root).filter(function (b) {
      return b.getAttribute('data-promo-excluded') !== 'true';
    }).length;
    return selectedTileCount(root) + addons;
  }

  /* ---------- render ---------- */

  var GIFT_SVG =
    '<svg viewBox="0 0 32 32" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
    '<rect x="4" y="12" width="24" height="16" rx="2"/><path d="M3 8h26v4H3zM16 8v20"/>' +
    '<path d="M16 8c-1-3.5-3.2-5-5.2-5C9 3 8 4.2 8 5.5 8 7 9.6 8 12 8h4zm0 0c1-3.5 3.2-5 5.2-5C19 3 20 4.2 20 5.5 20 7 18.4 8 16 8z"/></svg>';

  function buildBlock(root, swatches, sig) {
    var block = document.createElement('div');
    block.className = 'rio-sel';
    block.setAttribute('data-sig', sig);

    var tierHtml = '';
    for (var t = 1; t <= TIER_MAX; t++) {
      tierHtml +=
        '<button type="button" class="rio-sel__tier" data-n="' + t + '">' +
        '<span>' + t + (t === TIER_MAX ? '+ sets' : t === 1 ? ' set' : ' sets') + '</span>' +
        '<strong>' + pctFor(t) + '% off</strong></button>';
    }

    var tileHtml = '';
    for (var i = 0; i < swatches.length; i++) {
      var sw = swatches[i];
      var solo = sw.getAttribute('data-kit-key') === 'solo';
      var ids = sw.getAttribute('data-kit-ids') || '';
      var vid = solo ? currentVariantId() : ids.split(',')[0];
      var img = qs('img', sw);
      var title = (sw.getAttribute('data-kit-title') || '').replace(/^\+/, '');
      tileHtml +=
        '<button type="button" class="rio-sel__tile' + (solo ? ' is-on' : '') + '" data-key="' +
        esc(sw.getAttribute('data-kit-key')) + '" data-ids="' + esc(ids) + '" data-vid="' + esc(vid) +
        '" aria-pressed="' + (solo ? 'true' : 'false') + '">' +
        '<span class="rio-sel__top"><span class="rio-sel__pill"></span><span class="rio-sel__icon" aria-hidden="true"></span></span>' +
        '<span class="rio-sel__img">' + (img ? '<img src="' + esc(img.getAttribute('src')) + '" alt="">' : '') + '</span>' +
        '<span class="rio-sel__name">' + esc(title) + '</span>' +
        '<span class="rio-sel__price"></span></button>';
    }

    block.innerHTML =
      '<p class="rio-sel__title">Build your bundle</p>' +
      '<p class="rio-sel__sub">Tap to add as many as you like. The more you add, the more you save.</p>' +
      '<span class="rio-sel__bar"><span class="rio-sel__fill"></span></span>' +
      '<div class="rio-sel__tiers">' + tierHtml + '</div>' +
      '<div class="rio-sel__grid">' + tileHtml + '</div>' +
      '<div class="rio-sel__banner">' + GIFT_SVG +
      '<span><span class="rio-sel__banner-title"></span><span class="rio-sel__banner-sub"></span></span></div>';
    return block;
  }

  function refresh(root) {
    var block = qs('.rio-sel', root);
    if (!block) return;
    var tiles = tilesOf(block);
    var n = unitCount(root);
    var tier = Math.min(Math.max(n, 1), TIER_MAX);

    var fill = qs('.rio-sel__fill', block);
    if (fill) {
      var w = (Math.min(n, TIER_MAX) / TIER_MAX * 100).toFixed(2) + '%';
      if (fill.style.width !== w) fill.style.width = w;
    }

    qsa('.rio-sel__tier', block).forEach(function (chip) {
      var tn = parseInt(chip.getAttribute('data-n'), 10);
      var active = n > 0 && tn === tier;
      if (chip.classList.contains('is-active') !== active) chip.classList.toggle('is-active', active);
      setAttr(chip, 'aria-pressed', active ? 'true' : 'false');
      var chipPct = qs('strong', chip);
      if (chipPct) setText(chipPct, pctFor(tn) + '% off');
    });

    var nextList = 0;
    tiles.forEach(function (tile) {
      var cents = listCents(tile.getAttribute('data-vid'));
      if (cents > 0) setAttr(tile, 'data-cents', String(cents));
      var on = isOn(tile);
      if (tile.classList.contains('is-on') !== on) tile.classList.toggle('is-on', on);
      var pill = qs('.rio-sel__pill', tile);
      var price = qs('.rio-sel__price', tile);
      if (on) {
        setText(pill, pctFor(tier) + '% off');
        setText(price, cents > 0 ? money(unitCents(cents, tier)) + ' each' : '');
      } else {
        if (!nextList && cents > 0) nextList = cents;
        setText(pill, 'Add \u00b7 ' + pctFor(n + 1) + '% off');
        setText(price, cents > 0 ? '+ ' + money(unitCents(cents, n + 1)) : '');
      }
    });

    var lists = selectedLists(root);
    var title = qs('.rio-sel__banner-title', block);
    var sub = qs('.rio-sel__banner-sub', block);
    var ship = ' + free shipping';
    if (n === 0) {
      setText(title, 'Add a set \u2192 ' + pctFor(1) + '% off');
      setText(sub, 'Add a 2nd set for ' + pctFor(2) + '% off' + ship + '.');
    } else if (n < TIER_MAX) {
      var next = n + 1;
      if (!nextList) nextList = lists[0] || 0;
      var unit = unitCents(nextList, next);
      var marginal = totalCents(lists.concat([nextList]), next) - totalCents(lists, n);
      setText(title, 'Add a ' + ORD[next] + ' set \u2192 ' + pctFor(next) + '% off ' + (WORDS[next] || 'all') +
        (next === FREE_SHIP_UNITS ? ship : ''));
      setText(sub, unit > 0
        ? 'Just ' + money(unit) + ' each. Your ' + ORD[next] + ' set is effectively ' + money(marginal) + '.' +
          (n >= FREE_SHIP_UNITS ? ' Free shipping unlocked.' : '')
        : '');
    } else {
      setText(title, 'Best price unlocked \u2192 ' + pctFor(TIER_MAX) + '% off every set');
      setText(sub, 'Every set in your bundle gets the ' + pctFor(TIER_MAX) + '% price, with free shipping.');
    }
    applyOverride(root);
  }

  /* ---------- viewed product deselected: label + submit ---------- */

  function atcParts() {
    return {
      btn: qs('[id^="ProductSubmitButton-"]'),
      label: qs('[id^="AddToCartText-"]')
    };
  }

  // The kit and the theme's buy-buttons script both build the Add to cart label,
  // sticky bar total and PDP price block from main product + selected extras, with
  // the main price read through RioIgPrice.getListPriceCents. While the viewed tile
  // is off, report -1 for the viewed variant there so every total drops that unit.
  // (rio-ig-price.js calls its own internal copy, so its hydration is unaffected.)
  function wrapListPrice() {
    var r = window.RioIgPrice;
    if (!r || r.__rioSelOrigGetList || typeof r.getListPriceCents !== 'function') return;
    var orig = r.getListPriceCents;
    r.__rioSelOrigGetList = orig;
    r.getListPriceCents = function (variantId, fallback) {
      // -1, not 0: the kit does `getListPriceCents(...) || fallback`, and both callers skip values <= 0.
      if (window.__rioSelViewedOff && String(variantId) === currentVariantId()) return -1;
      return orig.call(r, variantId, fallback);
    };
  }

  function applyOverride(root) {
    var off = viewedOff(root);
    if (document.documentElement.classList.contains('rio-sel-viewed-off') !== off) {
      document.documentElement.classList.toggle('rio-sel-viewed-off', off);
    }
  }

  function addExtrasOnly(submitter) {
    if (window.__rioManagedCompanionCartBusy) return;
    var seen = {};
    var items = [];
    qsa('[data-city-product-multi-add-toggle][aria-pressed="true"]').forEach(function (b) {
      var id = parseInt(b.getAttribute('data-variant-id'), 10);
      if (id > 0 && !seen[id]) { seen[id] = true; items.push({ id: id, quantity: 1 }); }
    });
    if (!items.length) return;
    window.__rioManagedCompanionCartBusy = true;
    var done = false;
    if (submitter) { submitter.setAttribute('aria-disabled', 'true'); submitter.classList.add('btn--loading'); }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (res) { if (!res.ok) throw new Error('Cart add failed'); return res.text(); })
      .then(function () { return fetch('/cart.js'); })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        done = true;
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));
        try {
          if (window.FoxTheme && FoxTheme.pubsub && FoxTheme.pubsub.publish) {
            FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cart });
          }
        } catch (e) {}
        qsa('cart-count').forEach(function (el) {
          el.innerText = cart.item_count > 99 ? '99+' : cart.item_count;
          el.hidden = cart.item_count === 0;
        });
        document.documentElement.classList[cart.item_count === 0 ? 'remove' : 'add']('cart-has-items');
      })
      .catch(function (err) { if (window.console) console.error(err); })
      .then(function () {
        window.__rioManagedCompanionCartBusy = false;
        if (submitter) { submitter.classList.remove('btn--loading'); submitter.removeAttribute('aria-disabled'); }
        if (done) resetSelection();
      });
  }

  function resetSelection() {
    var root = document.getElementById(ROOT_ID);
    var block = root && qs('.rio-sel', root);
    if (!block) return;
    tilesOf(block).forEach(function (t) { setTile(t, t.getAttribute('data-key') === 'solo'); });
    qsa('.rio-pdp-addon__check:checked', root).forEach(function (b) {
      b.checked = false;
      var row = b.closest('.rio-pdp-addon');
      if (row) row.classList.remove('is-checked');
    });
    commit(root);
  }

  function onSubmit(event) {
    var root = document.getElementById(ROOT_ID);
    if (!root || !qs('.rio-sel', root) || !viewedOff(root)) return;
    var form = event.target;
    if (!form || !form.matches) return;
    var mine = form.matches('form.main-product-form') || (form.closest && form.closest('sticky-atc-bar'));
    if (!mine) return;
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    addExtrasOnly(event.submitter || null);
  }

  /* ---------- actions ---------- */

  function commit(root) {
    var block = qs('.rio-sel', root);
    var holder = qs('.rio-pdp-swatches', root);
    if (!block || !holder) return;
    var ids = [];
    tilesOf(block).forEach(function (tile) {
      if (!isOn(tile)) return;
      var raw = tile.getAttribute('data-ids');
      if (raw) ids = ids.concat(raw.split(',').filter(Boolean));
    });
    var combo = qs('[data-kit-key="' + COMBO_KEY + '"]', holder);
    if (!combo) {
      combo = document.createElement('button');
      combo.type = 'button';
      combo.className = 'rio-pdp-swatch';
      combo.hidden = true;
      combo.setAttribute('role', 'listitem');
      combo.setAttribute('data-kit-key', COMBO_KEY);
      combo.setAttribute('data-kit-title', 'Bundle');
      holder.appendChild(combo);
    }
    combo.setAttribute('data-kit-ids', ids.join(','));
    window.__rioSelViewedOff = viewedOff(root);
    combo.click();
    refresh(root);
  }

  function setTile(tile, on) {
    tile.setAttribute('aria-pressed', on ? 'true' : 'false');
    tile.classList.toggle('is-on', on);
  }

  function bind(root, block) {
    block.addEventListener('click', function (event) {
      var target = event.target;
      if (!target || !target.closest) return;

      var tile = target.closest('.rio-sel__tile');
      if (tile && block.contains(tile)) {
        event.preventDefault();
        // Keep at least one set (or an add-on) in the cart.
        if (isOn(tile) && selectedTileCount(root) === 1 && !checkedAddonCount(root)) return;
        setTile(tile, !isOn(tile));
        commit(root);
        return;
      }

      var chip = target.closest('.rio-sel__tier');
      if (chip && block.contains(chip)) {
        event.preventDefault();
        var want = parseInt(chip.getAttribute('data-n'), 10) || 1;
        var addons = unitCount(root) - selectedTileCount(root);
        var tiles = tilesOf(block);
        var keep = Math.min(Math.max(want - addons, 1), tiles.length);
        tiles.forEach(function (t, idx) { setTile(t, idx < keep); });
        commit(root);
      }
    });

    if (root.getAttribute('data-rio-sel-bound') !== '1') {
      root.setAttribute('data-rio-sel-bound', '1');
      var later = function () { setTimeout(function () { refresh(root); }, 0); };
      root.addEventListener('change', later);
      root.addEventListener('click', later);
    }
  }

  function ensure() {
    wrapListPrice();
    var root = document.getElementById(ROOT_ID);
    if (!root) return;
    var kits = qs('.rio-pdp-kits', root);
    if (!kits) return;
    if (!offerMatches()) {
      var stale = qs('.rio-sel', root);
      if (stale && stale.parentNode) stale.parentNode.removeChild(stale);
      root.classList.remove('rio-sel-active');
      document.documentElement.classList.remove('rio-sel-viewed-off');
      return;
    }
    var swatches = qsa('.rio-pdp-swatch', kits).filter(function (s) {
      return s.getAttribute('data-kit-key') !== COMBO_KEY;
    });
    if (swatches.length < 2) return;

    var sig = swatches.map(function (s) {
      return s.getAttribute('data-kit-key') + ':' + (s.getAttribute('data-kit-ids') || '');
    }).join('|');

    var block = qs('.rio-sel', root);
    if (block && block.getAttribute('data-sig') === sig) {
      refresh(root);
      return;
    }
    if (block && block.parentNode) block.parentNode.removeChild(block);

    block = buildBlock(root, swatches, sig);
    kits.parentNode.insertBefore(block, kits.nextSibling);
    root.classList.add('rio-sel-active');
    bind(root, block);
    refresh(root);
  }

  function boot() {
    document.addEventListener('city-product-multi-add:selection-changed', function () {
      var root = document.getElementById(ROOT_ID);
      if (root) refresh(root);
    });
    document.addEventListener('rio:ig-price-ready', function () {
      var root = document.getElementById(ROOT_ID);
      if (root) refresh(root);
    });
    // Theme clears the multi-add toggles after a successful add. Reset the UI to match.
    document.addEventListener('city-product-dropdown-multi-add:clear-selections', function () {
      setTimeout(resetSelection, 0);
    });
    document.addEventListener('submit', onSubmit, true);

    ensure();
    var tries = 0;
    var retry = setInterval(function () {
      tries += 1;
      ensure();
      if (tries >= 40) clearInterval(retry);
    }, 250);

    var host = qs('[id^="ProductInfo-"]') || qs('.product__info-container') || document.body;
    var timer = null;
    new MutationObserver(function () {
      if (timer) clearTimeout(timer);
      timer = setTimeout(ensure, 60);
    }).observe(host, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
